import { lazy } from 'react';
import { Routes } from './utils/renderRoutes';

const siteServiceRoutes: Routes[] = [
    {
        title: '现场服务',
        path: '/site-service',
        component: lazy(() => import('@/views/SiteService')),
        children: [
            {
                title: '租赁服务',
                path: '/site-service/lease',
                component: lazy(() => import('@/views/SiteService/Lease')),
            },
            {
                title: '发票登记',
                path: '/site-service/invoice',
                component: lazy(() => import('@/views/SiteService/Invoice')),
            },
            {
                title: '退税登记',
                path: '/site-service/drawback',
                component: lazy(() => import('@/views/SiteService/Drawback')),
            },
            {
                title: '礼品包装',
                path: '/site-service/giftwrap',
                component: lazy(() => import('@/views/SiteService/GiftWrap')),
            },
            {
                title: '商品快递',
                path: '/site-service/express',
                component: lazy(() => import('@/views/SiteService/Express')),
            },
            {
                title: '第三方积分',
                path: '/site-service/third',
                component: lazy(() => import('@/views/SiteService/Third')),
            },
            {
                title: '投诉建议',
                path: '/site-service/suggest',
                component: lazy(() => import('@/views/SiteService/Suggest')),
            },
            {
                title: '失物招领',
                path: '/site-service/l-and-f',
                component: lazy(() => import('@/views/SiteService/LostAndFound/index')),
                children: [
                    {
                        title: '失物招领',
                        path: '/site-service/l-and-f/list',
                        component: lazy(() => import('@/views/SiteService/LostAndFound/List')),
                    },
                    {
                        title: '新增失物招领',
                        path: '/site-service/l-and-f/create',
                        component: lazy(() => import('@/views/SiteService/LostAndFound/CreateLose')),
                    },
                    {
                        redirect: true,
                        from: '/site-service/l-and-f',
                        to: '/site-service/l-and-f/list',
                    },
                ]
            },
            {
                title: '行李寄存',
                path: '/site-service/luggage',
                component: lazy(() => import('@/views/SiteService/Luggage')),
            },
            {
                title: '其他服务',
                path: '/site-service/other',
                component: lazy(() => import('@/views/SiteService/Other')),
            },
            {
                title: '服务记录',
                path: '/site-service/record',
                component: lazy(() => import('@/views/SiteService/Record')),
                children: [
                    {
                        title: '服务记录查询',
                        path: '/site-service/record/list',
                        component: lazy(() => import('@/views/SiteService/Record/List')),
                    },
                    {
                        title: '服务记录详情',
                        path: '/site-service/record/info',
                        component: lazy(() => import('@/views/SiteService/Record/Info')),
                        children: [
                            {
                                title: '租赁记录详情',
                                path: '/site-service/record/info/lease/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Lease')),
                            },
                            {
                                title: '发票记录详情',
                                path: '/site-service/record/info/invoice/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Invoice')),
                            },
                            {
                                title: '投诉建议记录详情',
                                path: '/site-service/record/info/suggest/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Suggest')),
                            },
                            {
                                title: '礼品包装记录详情',
                                path: '/site-service/record/info/giftwrap/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/GiftWrap')),
                            },
                            {
                                title: '商品快递记录详情',
                                path: '/site-service/record/info/express/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Express')),
                            },
                            {
                                title: '第三方积分记录详情',
                                path: '/site-service/record/info/third/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Third')),
                            },
                            {
                                title: '退税记录详情',
                                path: '/site-service/record/info/drawback/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Drawback')),
                            },
                            {
                                title: '失物招领记录详情',
                                path: '/site-service/record/info/l-and-f/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Lose')),
                            },
                            {
                                title: '行李寄存记录详情',
                                path: '/site-service/record/info/luggage/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Luggage')),
                            },
                            {
                                title: '其他服务记录详情',
                                path: '/site-service/record/info/other/:id',
                                component: lazy(() => import('@/views/SiteService/Record/Info/Other')),
                            },
                        ]
                    },
                    {
                        redirect: true,
                        from: '/site-service/record',
                        to: '/site-service/record/list',
                    },
                ]
            },
            {
                redirect: true,
                from: '/site-service',
                to: '/site-service/lease',
            },
        ],
    },
];
export default siteServiceRoutes;